module.exports = __webpack_public_path__ + "media/newstyle/images/new-icon-facebook-0bfc682874e425c8c661c97f1d73ddb4.svg";